module.exports = __webpack_public_path__ + "img/jslc1.f44c6a1e.png";